import { useEffect } from 'react';
import { getCelloConfig } from './celloConfig';

export function CelloAttribution() {
  const celloConfig = getCelloConfig();

  useEffect(() => {
    if (!celloConfig.active) return;
    const script = document.createElement('script');
    script.type = 'module';
    script.src = celloConfig.attributionLib;
    script.async = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return <></>;
}
